import { Component, Input, OnChanges } from '@angular/core';
import { ExpenseClaimReceiptModel } from '../../core/models/expense.model';
import moment from 'moment';

@Component({
  selector: 'app-expense-ai-receipt-date',
  templateUrl: './expense-ai-receipt-date.component.html',
  styleUrls: ['./expense-ai-receipt-date.component.scss']
})
export class ExpenseAiReceiptDateComponent implements OnChanges {
  @Input() receipts: ExpenseClaimReceiptModel[] = [];
  @Input() visitDate?: Date;
  @Input() visitEndDate?: Date;
  @Input() visitTravelDays?: number;
  @Input() size: 'md' | 'sm' = 'md';

  hasDateData = false;
  isRange = false;
  displayText = '';
  dateMatchesVisit = true;
  tooltipText: string | null = null;

  ngOnChanges(): void {
    const dates = (this.receipts || [])
      .filter(r => r.transactionDate != null)
      .map(r => moment(r.transactionDate))
      .sort((a, b) => a.valueOf() - b.valueOf());

    this.hasDateData = dates.length > 0;
    if (!this.hasDateData) return;

    const uniqueDates = [...new Set(dates.map(d => d.format('DD MMM YY')))];

    if (uniqueDates.length === 1) {
      this.isRange = false;
      this.displayText = uniqueDates[0];
    } else {
      this.isRange = true;
      this.displayText = `${uniqueDates[0]} - ${uniqueDates[uniqueDates.length - 1]}`;
    }

    if (this.visitDate) {
      const travelBuffer = this.visitTravelDays ? Math.ceil(this.visitTravelDays / 2) : 0;

      const rangeStart = new Date(this.visitDate);
      rangeStart.setHours(0, 0, 0, 0);
      rangeStart.setDate(rangeStart.getDate() - travelBuffer);

      const rangeEnd = this.visitEndDate ? new Date(this.visitEndDate) : new Date(this.visitDate);
      rangeEnd.setHours(0, 0, 0, 0);
      rangeEnd.setDate(rangeEnd.getDate() + travelBuffer);

      this.dateMatchesVisit = dates.every(d => {
        const txn = d.toDate();
        txn.setHours(0, 0, 0, 0);
        return txn >= rangeStart && txn <= rangeEnd;
      });
    } else {
      this.dateMatchesVisit = true;
    }

    this.tooltipText = !this.dateMatchesVisit ? this.buildTooltip() : null;
  }

  private buildTooltip(): string {
    const visitStart = moment(this.visitDate).format('D MMM YYYY');
    const visitEnd = this.visitEndDate ? ' - ' + moment(this.visitEndDate).format('D MMM YYYY') : '';
    const travelDays = this.visitTravelDays ? ` +/- ${this.visitTravelDays} travel days` : '';
    return `Receipt date (${this.displayText}) falls outside the visit date range (${visitStart}${visitEnd}${travelDays})`;
  }
}
